import { combineEpics } from 'redux-observable';
import { filter, tap, take, ignoreElements } from 'rxjs/operators';

import { authorizeWithOtpSuccess } from '../../features/account/reducer/session';
import { RootEpic } from '../../store/epics';
import { portalTypeSelector } from '../selectors/portal-type.selector';

type BlackboxConfig = {
  enable_rip: boolean;
  enable_flash: boolean;
  install_flash: boolean;
  bb_callback: (blackBoxString: string, isComplete: boolean) => void;
  loader: {
    uri_hook: string;
    version: 'general5' | 'early5';
    fp_static: boolean;
  };
};

type BlackboxWindow = {
  io_global_object_name?: string;
  IGLOO?: BlackboxConfig;
} & Window;

let blackbox = '';

const startBlackboxScriptsEpic: RootEpic = (action$, state$, { window }) => {
  return action$.pipe(
    take(1),
    tap(() => loadBlackboxConfig(window)),
    tap(() => loadBlackboxScripts(window.document)),
  );
};

const saveBlackboxEpic: RootEpic = (action$, state$, { api }) => {
  return action$.pipe(
    filter(authorizeWithOtpSuccess.match),
    filter(() => portalTypeSelector(state$.value) === 'apply'),
    tap(async () => {
      try {
        await api.deviceData.saveDeviceData({ blackbox });
      } catch (_error) {
        console.dir('Error saving blackbox.');
      }
    }),
    ignoreElements(),
  );
};

const loadBlackboxConfig = (window: BlackboxWindow) => {
  window.io_global_object_name = 'IGLOO';
  if (!window.IGLOO) {
    window.IGLOO = {
      enable_rip: true,
      enable_flash: false,
      install_flash: false,
      bb_callback: (blackBoxString: string, isComplete: boolean) => {
        if (isComplete) {
          blackbox = blackBoxString;
        }
      },
      loader: {
        uri_hook: 'iojs',
        version: 'general5',
        fp_static: true,
      },
    };
  }
};

const loadBlackboxScripts = (document: Document) => {
  const script: HTMLScriptElement = document.createElement('script');
  script.src = 'io-loader.js';
  script.async = true;
  document.body.appendChild(script);
};

export const iovationBlackboxEpic = combineEpics(startBlackboxScriptsEpic, saveBlackboxEpic);
